import {
  withCompInfo,
  withCompPreviewInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import type {
  ClassicSectionDefinition,
  ClassicSectionCarmiData,
  ClassicSectionCss,
} from '../ClassicSection.types';
import { TranslationKeys } from '../constants';

export const props = withCompInfo<
  ClassicSectionCarmiData,
  ClassicSectionDefinition,
  ClassicSectionCarmiData
>()(['translate'], ({ translate }, carmiData) => {
  return {
    ...carmiData,
    translations: {
      ariaLabel: translate(
        TranslationKeys.namespace,
        TranslationKeys.ariaLabel,
      ),
      playLabel: translate(
        TranslationKeys.namespace,
        TranslationKeys.playLabel,
      ),
      pauseLabel: translate(
        TranslationKeys.namespace,
        TranslationKeys.pauseLabel,
      ),
    },
  };
});

export const css = withCompPreviewInfo<
  ClassicSectionCss,
  ClassicSectionDefinition,
  ClassicSectionCss
>()([], (_, carmiData) => {
  return carmiData;
});

const stateRefs = withStateRefsValues(['experiments']);

export default createComponentMapperModel({
  props,
  css,
  stateRefs,
});
